/**
 * 使用数据导出文件
 * 2018.8.2
 * Harry
 * 
 * 传入的数据格式
 * {
 *   fileNmae: '',
 *   sheetNames: [],
 *   sheets: {}
 * }
 * 
 */

import xlsx from 'xlsx'
import fs from 'file-saver'

function exportFile (options = {}) {
  if (typeof options !== 'object' || Array.isArray(options)) {
    this.$message({
      message: 'ExportFile.js: 传入参数错误。',
      type: 'error'
    })
    return false
  }
  this.sheetName = options.sheetName
  this.pickData = options.pickData
}

exportFile.prototype.exportExcel = function () {
  let tmpDown, tmpdata, keyMap, outputPos, wb, href
  tmpdata = this.pickData[0]
  this.pickData.unshift({})
  keyMap = []
  for (var k in tmpdata) {
    keyMap.push(k);
    this.pickData[0][k] = k;
  }
  //用来保存转换好的this.pickData 
  tmpdata = [];
  this.pickData.map((v, i) =>
    keyMap.map((k, j) =>
      Object.assign(
        {}, 
        {v: v[k], position: (j > 25 ? this.__getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)})
      )).reduce((prev, next) => 
    prev.concat(next)
  ).forEach((v, i) => {
    tmpdata[v.position] = {v: v.v}
  })

  //设置区域,比如表格从A1到D10
  outputPos = Object.keys(tmpdata); 
  wb = {
    SheetNames: [this.sheetName], //保存的表标题
    Sheets: {}
  }
  wb.Sheets[this.sheetName] = Object.assign({},
    tmpdata, //内容
    { 
      '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
    }
  )
  //创建二进制对象写入转换好的字节流
  tmpDown = new Blob([this.__s2ab(xlsx.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary'}))], { type: '' }) 
  //创建对象超链接
  href = URL.createObjectURL(tmpDown)
  URL.revokeObjectURL(tmpDown)
  return href
}

//字符串转字符流 
exportFile.prototype.__s2ab = function (s) {
  let buf = new ArrayBuffer(s.length)
  let view = new Uint8Array(buf)
  for(let i = 0; i != s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF
  }
  return buf
}
// 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
exportFile.prototype.__getCharCol = function (n) {
  let temCol = '',
  s = '',
  m = 0
  while (n > 0) {
    m = n % 26 + 1
    s = String.fromCharCode(m + 64) + s
    n = (n - m) / 26
  }
  return s
}

export default exportFile



// WEBPACK FOOTER //
// ./src/common/js/exportFile.js